export const data = [
    {
        title: '2001',
        text: 'UniferX is founded in Germany by experts in the field of agronomy and biotechnology',
    },
    {
        title: '2002 - 2006',
        text: 'Start of cooperation with large agricultural groups in Ukraine and Germany',
    },
    {
        title: '2007 - 2013',
        text: 'Creating a wide range of microfertilizers to improve plant nutrition',
    },
    {
        title: '2014 - 2020',
        text: 'We bring our products to international markets and obtain quality certificates',
    },
    {
        title: '2021 - 2022',
        text: 'Expanding operations in Moldova and Kazakhstan, opening its own research centers',
    },
    {
        title: '2023 - Future',
        text: "Launch of the company's new global website and growth of new eco-friendly products",
    },
];
